module.exports = __webpack_public_path__ + "little-img.svg?f5f23310c0f8118ffd3f87c4ffb5507b";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/little-img.svg
// module id = 321
// module chunks = 0